import a from "react";
import { getIconColor as r } from "./iconfont.es5470.js";
import v from "./iconfont.es5471.js";
const i = {
  display: "block"
}, x = ({ size: t = 16, useVw: n, useRem: o, color: c, withColor: h, removeClassName: e, disableSSR: d, style: l, ...m }) => {
  const p = l ? { ...i, ...l } : i;
  return /* @__PURE__ */ a.createElement(v, { disableSSR: d }, /* @__PURE__ */ a.createElement("svg", { "data-icon-id": "24px-chongzhi", "data-icon-group": "GateHeader", "data-icon-version": "0.8.1", viewBox: "0 0 24 24", width: n ? ((t || 0) / 375 * 100).toFixed(5) + "vw" : t + (o ? "rem" : "px"), height: n ? ((t || 0) / 375 * 100).toFixed(5) + "vw" : t + (o ? "rem" : "px"), className: e ? "" : "iconpark-icon", style: p, fill: "none", ...m }, /* @__PURE__ */ a.createElement(
    "g",
    {
      className: e ? "" : "24px-åå¼"
    },
    /* @__PURE__ */ a.createElement(
      "g",
      {
        className: e ? "" : "normal",
        fill: h ? r(c, 0, "#262933") : "#262933",
        datafollowfill: h ? r(c, 0, "#262933") : "#262933"
      },
      /* @__PURE__ */ a.createElement(
        "path",
        {
          d: "M18.5 2.911a.8.8 0 0 1 .8.8v.392h.858a.8.8 0 0 1 0 1.6h-2.935a.353.353 0 0 0 0 .707h2.389a1.953 1.953 0 0 1 0 3.907H19.3v.322a.8.8 0 0 1-1.6 0v-.322h-1.396a.8.8 0 1 1 0-1.6h3.308a.353.353 0 1 0 0-.707h-2.39a1.953 1.953 0 0 1 0-3.907h.478v-.392a.8.8 0 0 1 .8-.8ZM5.722 15.92a.8.8 0 0 1 .8-.8h4.174a.8.8 0 0 1 0 1.6H6.522a.8.8 0 0 1-.8-.8Z"
        }
      ),
      /* @__PURE__ */ a.createElement(
        "path",
        {
          d: "M3.8 7.214c0-.801.65-1.45 1.45-1.45h7.533a.8.8 0 0 0 0-1.6H5.25a3.05 3.05 0 0 0-3.05 3.05v10.5a3.05 3.05 0 0 0 3.05 3.05h13.5a3.05 3.05 0 0 0 3.05-3.05v-4.142a.8.8 0 1 0-1.6 0v4.142c0 .8-.65 1.45-1.45 1.45H5.25c-.8 0-1.45-.65-1.45-1.45v-7.506c.294.118.614.183.95.183h8.033a.8.8 0 0 0 0-1.6H4.75a.95.95 0 0 1-.95-.95v-.627Z"
        }
      )
    )
  )));
}, s = x;
export {
  s as default
};
